import React from 'react'
import { styled } from '@mui/material/styles'
import { Grid, Typography } from '@mui/material'

export const GridWithRightBorder = styled(Grid)(
  ({ theme }) => `
    border-right: 1px solid ${theme.palette.borderColor.default};
    padding: ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} 0;
  `,
)

export const GridWithBottomBorder = styled(Grid)(
  ({ theme }) => `
    border-bottom: 1px solid ${theme.palette.borderColor.default};
    padding: ${theme.spacing(1)} 0 ${theme.spacing(1)} 0;
  `,
)

export const GridSpacer = styled(props => (
  <Grid item mt={2} {...props}>
    {props.children}
  </Grid>
))``

export const Title = styled(props => (
  <Typography variant="h6" {...props}>
    {props.children}
  </Typography>
))``

export const Caption = styled(props => (
  <Typography variant="caption" color="textSecondary" {...props}>
    {props.children}
  </Typography>
))``

export const LogoContainer = styled('div')`
  display: flex;

  svg {
    width: 84px;
    height: 88px;
  }
`
export const PrintableReceiptLabel = styled(props => (
  <Typography variant="body2" style={{ fontWeight: 600 }} {...props}>
    {props.children}
  </Typography>
))``
